import React from 'react';
type SectionLabelProps = {
  children: React.ReactNode;
  tone?: 'dark' | 'light';
};
export function SectionLabel({
  children,
  tone = 'dark'
}: SectionLabelProps) {
  return <div className="flex items-center gap-4" data-id="element-153" data-mp="2a026ifc63jtr">
      <span className={`h-px w-10 ${tone === 'dark' ? 'bg-pine-900/30' : 'bg-pine-200/60'}`} aria-hidden="true" data-id="element-154" data-mp="2a1dj94nlc1x0" />
      <p className={`text-[11px] uppercase tracking-widest2 ${tone === 'dark' ? 'text-pine-800' : 'text-pine-200'}`} data-id="element-155" data-mp="2e3gxu25k3mmi">
        {children}
      </p>
    </div>;
}